export const fonts = {
  baseFontFamily: 'BlinkMacSystemFont, -apple-system, Segoe UI, Roboto,\n' +
  '  Helvetica, Arial, sans-serif'
}



// WEBPACK FOOTER //
// ./src/style/styled-components/settings/fonts.js